(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!window.bundleUpsellTrackingBound) {
    window.bundleUpsellTrackingBound = true;

    document.addEventListener('click', function (event) {
      if (window.Shopify?.designMode || !(event.target instanceof Element)) return;

      const banner = event.target.closest('a.bundle-upsell__row[data-bundle-name]');
      if (!banner || typeof window.mixpanel?.track !== 'function') return;

      window.mixpanel.track('Bundle Upsell Clicked', {
        bundle_name: banner.dataset.bundleName,
        pack_quantity: Number(banner.dataset.packQuantity),
        product_viewed: banner.dataset.productViewed
      }, { transport: 'sendBeacon', send_immediately: true });
    });
  }
  if (!window.bundleUpsellViewTrackingBound && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
    window.bundleUpsellViewTrackingBound = true;

    function observeBundleUpsells() {
      document.querySelectorAll('.bundle-upsell[data-product-viewed]').forEach(function (section) {
        let timer = null;
        let inView = false;
        let tracked = false;

        function cancelTimer() {
          clearTimeout(timer);
          timer = null;
        }

        function updateTimer() {
          if (tracked || !inView || document.hidden || !section.isConnected) {
            cancelTimer();
            return;
          }
          if (timer !== null) return;

          timer = setTimeout(function () {
            timer = null;
            const pending = observer.takeRecords();
            if (pending.length) {
              handleEntries(pending);
              return;
            }
            if (tracked || !inView || document.hidden || !section.isConnected) return;
            if (typeof window.mixpanel?.track !== 'function') {
              updateTimer();
              return;
            }

            window.mixpanel.track('Bundle Upsell Viewed', {
              product_viewed: section.dataset.productViewed
            });
            tracked = true;
            observer.disconnect();
            document.removeEventListener('visibilitychange', handleVisibility);
          }, 1000);
        }

        function handleEntries(entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            updateTimer();
          });
        }

        function handleVisibility() {
          cancelTimer();
          inView = false;
          observer.unobserve(section);
          if (!document.hidden) observer.observe(section);
        }

        const observer = new IntersectionObserver(handleEntries, { threshold: 0.5 });
        document.addEventListener('visibilitychange', handleVisibility);
        observer.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeBundleUpsells, { once: true });
    } else {
      observeBundleUpsells();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Initialize mobile predictive search (it will only affect mobile due to CSS)
      this.initMobilePredictiveSearch();
    }

    initMobilePredictiveSearch() {
      const mobilePredictiveSearch = document.querySelector('.mobile-predictive-search');
      const mobileSearchBar = document.querySelector('.mobile-search-bar');
      if (!mobilePredictiveSearch || !mobileSearchBar) return;
      
      const mobileSearchInput = mobilePredictiveSearch.querySelector('.mobile-search-input');
      const resultsContainer = mobilePredictiveSearch.querySelector('.mobile-predictive-search__results-container');
      const cancelButton = mobilePredictiveSearch.querySelector('.mobile-search-cancel');
      
      if (!mobileSearchInput || !resultsContainer) return;
      
      let debounceTimer;
      
      // Handle focus - show fullscreen search
      mobileSearchInput.addEventListener('focus', () => {
        mobileSearchBar.classList.add('search-active');
        document.body.style.overflow = 'hidden'; // Prevent body scroll
        document.body.classList.add('mobile-search-active');
        
        // Ensure the search input is visible and focused after takeover
        setTimeout(() => {
          mobileSearchInput.scrollIntoView({ behavior: 'instant', block: 'start' });
          mobileSearchInput.focus();
        }, 50);
      });
      
      // Handle cancel button
      if (cancelButton) {
        cancelButton.addEventListener('click', () => {
          mobileSearchBar.classList.remove('search-active');
          mobilePredictiveSearch.removeAttribute('open');
          mobileSearchInput.setAttribute('aria-expanded', 'false');
          mobileSearchInput.value = '';
          
          // Only remove search results, keep default content
          const resultsWrapper = resultsContainer.querySelector('.mobile-search-results-wrapper');
          if (resultsWrapper) {
            resultsWrapper.remove();
          }
          
          // Make sure default content is visible
          const defaultContent = resultsContainer.querySelector('.mobile-search-default-content');
          if (defaultContent) {
            defaultContent.style.display = 'block';
          }
          
          document.body.style.overflow = '';
          document.body.classList.remove('mobile-search-active');
          mobileSearchInput.blur();
        });
      }
      
      // Handle input events
      // Handle input events
    mobileSearchInput.addEventListener('input', (event) => {
      clearTimeout(debounceTimer);
      const searchTerm = event.target.value.trim();
      const defaultContent = resultsContainer.querySelector('.mobile-search-default-content');
      const resultsWrapper = resultsContainer.querySelector('.mobile-search-results-wrapper');
      
      if (searchTerm.length > 0) {
        mobilePredictiveSearch.setAttribute('open', '');
        mobileSearchInput.setAttribute('aria-expanded', 'true');
        
        // Hide default content
        if (defaultContent) {
          defaultContent.style.display = 'none';
        }
        
        // Remove previous search results
        if (resultsWrapper) {
          resultsWrapper.remove();
        }
        
        // Debounce search requests
        debounceTimer = setTimeout(() => {
          this.fetchPredictiveSearchResults(searchTerm, resultsContainer);
        }, 300);
      } else {
        // Show default content when input is empty
        if (defaultContent) {
          defaultContent.style.display = 'block';
        }
        // Remove search results
        if (resultsWrapper) {
          resultsWrapper.remove();
        }
      }
    });
      
      // Handle keyboard navigation
      mobileSearchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          mobileSearchBar.classList.remove('search-active');
          mobilePredictiveSearch.removeAttribute('open');
          mobileSearchInput.setAttribute('aria-expanded', 'false');
          mobileSearchInput.blur();
          document.body.classList.remove('mobile-search-active');
          document.body.style.overflow = '';
        }
      });
      
      // Prevent clicking outside from closing when search is active
      document.addEventListener('click', (event) => {
        // Only close if clicking outside and search is not active
        if (!mobileSearchBar.classList.contains('search-active') && !mobilePredictiveSearch.contains(event.target)) {
          mobilePredictiveSearch.removeAttribute('open');
          mobileSearchInput.setAttribute('aria-expanded', 'false');
        }
      });
    }
    
    async fetchPredictiveSearchResults(searchTerm, container) {
      try {
        const existingWrapper = container.querySelector('.mobile-search-results-wrapper');
        if (existingWrapper) existingWrapper.remove();

        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        const localePrefix = pathSegments[0] && pathSegments[0].length <= 5 && !['search','products','collections','pages'].includes(pathSegments[0]) ? `/${pathSegments[0]}` : '';

        const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product,page,article&resources[limit]=10&section_id=predictive-search`);

        // 417 = non-default locale, use fallback scraper
        if (response.status === 417) {
          if (localePrefix) {
            this.showMobileFallbackSkeleton(container);
            return this.fetchMobileFallback(searchTerm, container, localePrefix);
          }
          return;
        }

        if (!response.ok) return;

        // Response is HTML (section rendering) — parse it
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const sectionInner = doc.querySelector('#shopify-section-predictive-search');
        if (!sectionInner) return;

        const productItems = Array.from(sectionInner.querySelectorAll('.predictive-search__item--link-with-thumbnail'));
        const locale = document.documentElement.lang || 'en';
        const productsText = { 'zh-CN': '产品', 'zh-TW': '產品', 'fr': 'Produits', 'de': 'Produkte', 'es': 'Productos', 'ja': '製品', 'ar': 'منتجات' };
        const searchForText = { 'zh-CN': '搜索', 'zh-TW': '搜尋', 'fr': 'Rechercher', 'de': 'Suchen nach', 'es': 'Buscar', 'ja': '検索', 'ar': 'البحث عن' };

        let html = '';

        if (productItems.length > 0) {
          html += '<div class="predictive-search__result-group">';
          html += `<h3 class="predictive-search__heading">${productsText[locale] || 'Products'}</h3>`;
          productItems.forEach(item => {
            const href = item.getAttribute('href') || '';
            const img = item.querySelector('.predictive-search__image');
            const imgSrc = img?.getAttribute('src') || img?.getAttribute('srcset')?.split(' ')[0] || '';
            const title = item.querySelector('.predictive-search__item-heading')?.textContent.trim() || '';
            const vendor = item.querySelector('.predictive-search__item-vendor')?.textContent.trim() || '';
            const priceEl = item.querySelector('.price-item--sale, .price-item--regular');
            const price = priceEl?.textContent.trim() || '';
            const comparePriceEl = item.querySelector('.price-item--compare');
            const comparePrice = comparePriceEl?.textContent.trim() || '';
            const badgeEl = item.querySelector('.discount-percentage, .badge');
            const badge = badgeEl?.textContent.trim() || '';

            html += `
              <a href="${href}" class="mobile-predictive-search__item">
                ${imgSrc ? `<img src="${imgSrc}" alt="${title}" class="mobile-predictive-search__item-image">` : ''}
                <div class="mobile-predictive-search__item-content">
                  ${vendor ? `<div class="mobile-predictive-search__item-vendor">${vendor}</div>` : ''}
                  <div class="mobile-predictive-search__item-heading">${title}</div>
                  ${price ? `<div class="mobile-predictive-search__item-price" style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                    <span style="font-weight: 700;">${price}</span>
                    ${comparePrice ? `<span style="text-decoration: line-through; color: #666; font-size: 0.85em;">${comparePrice}</span>` : ''}
                    ${badge ? `<span style="color: #f4a340; font-weight: 700; font-size: 0.85em;">${badge}</span>` : ''}
                  </div>` : ''}
                </div>
              </a>
            `;
          });
          html += '</div>';
        }

        const pageItems = Array.from(sectionInner.querySelectorAll('[id*="pages"] .predictive-search__item')).filter((item, i, all) => { const href = (item.closest('a') || item.querySelector('a'))?.getAttribute('href'); return all.findIndex(o => (o.closest('a') || o.querySelector('a'))?.getAttribute('href') === href) === i; });
        if (pageItems.length > 0) {
          html += '<div class="predictive-search__result-group">';
          html += '<h3 class="predictive-search__heading">' + ({ 'zh-CN': '页面', 'zh-TW': '頁面', 'fr': 'Pages', 'de': 'Seiten', 'es': 'Páginas', 'ja': 'ページ', 'ar': 'الصفحات' }[document.documentElement.lang] || 'Pages') + '</h3>';
          pageItems.forEach(item => {
            const link = item.closest('a') || item.querySelector('a');
            html += `
              <a href="${link?.getAttribute('href') || ''}" class="mobile-predictive-search__item">
                <div class="mobile-predictive-search__item-content">
                  <div class="mobile-predictive-search__item-heading">${item.querySelector('.predictive-search__item-heading')?.textContent.trim() || ''}</div>
                </div>
              </a>
            `;
          });
          html += '</div>';
        }

        const articleItems = Array.from(sectionInner.querySelectorAll('[id*="articles"] .predictive-search__item')).filter((item, i, all) => { const href = (item.closest('a') || item.querySelector('a'))?.getAttribute('href'); return all.findIndex(o => (o.closest('a') || o.querySelector('a'))?.getAttribute('href') === href) === i; });
        if (articleItems.length > 0) {
          html += '<div class="predictive-search__result-group">';
          html += '<h3 class="predictive-search__heading">Articles</h3>';
          articleItems.forEach(item => {
            const link = item.closest('a') || item.querySelector('a');
            html += `
              <a href="${link?.getAttribute('href') || ''}" class="mobile-predictive-search__item">
                <div class="mobile-predictive-search__item-content">
                  <div class="mobile-predictive-search__item-heading">${item.querySelector('.predictive-search__item-heading')?.textContent.trim() || ''}</div>
                </div>
              </a>
            `;
          });
          html += '</div>';
        }

        html += `
          <div class="predictive-search__search-for-button">
            <button type="submit" class="predictive-search__item-link">
              ${searchForText[locale] || 'Search for'} "${searchTerm}" →
            </button>
          </div>
        `;

        const wrapper = document.createElement('div');
        wrapper.className = 'mobile-search-results-wrapper';
        wrapper.innerHTML = html;
        container.appendChild(wrapper);

      } catch (error) {
        console.error('Error fetching predictive search results:', error);
      }
    }
    showMobileFallbackSkeleton(container) {
      const defaultContent = container.querySelector('.mobile-search-default-content');
      if (defaultContent) defaultContent.style.display = 'none';

      const existing = container.querySelector('.mobile-search-results-wrapper');
      if (existing) existing.remove();

      const skeleton = document.createElement('div');
      skeleton.className = 'mobile-search-results-wrapper';
      skeleton.innerHTML = `
        <div class="predictive-search__skeleton">
          ${[1,2,3].map(() => `
            <div class="predictive-search__skeleton-item">
              <div class="predictive-search__skeleton-image"></div>
              <div class="predictive-search__skeleton-text">
                <div class="predictive-search__skeleton-line predictive-search__skeleton-line--short"></div>
                <div class="predictive-search__skeleton-line predictive-search__skeleton-line--long"></div>
                <div class="predictive-search__skeleton-line predictive-search__skeleton-line--medium"></div>
              </div>
            </div>
          `).join('')}
        </div>`;
      container.appendChild(skeleton);
    }
    
    async fetchMobileFallback(searchTerm, container, localePrefix) {
      try {
        const response = await fetch(`${localePrefix}/search?q=${encodeURIComponent(searchTerm)}&type=product`);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = Array.from(doc.querySelectorAll('#product-grid .grid__item')).slice(0, 6);

        const products = items.map(item => {
          const titleEl = item.querySelector('.card__heading a');
          return {
            title: titleEl?.textContent.trim() || '',
            url: titleEl?.getAttribute('href') || '',
            image: item.querySelector('.card__media img, .card img')?.getAttribute('src') || '',
            vendor: item.querySelector('.card__vendor, [class*="vendor"]')?.textContent.trim() || '',
            price: item.querySelector('.custom-price-current')?.textContent.trim() || '',
            compare_at_price: item.querySelector('.custom-price-original')?.textContent.trim() || '',
            badge: item.querySelector('.custom-price-badge')?.textContent.trim() || '',
          };
        });

        this.renderMobileFallbackResults(products, container, searchTerm, localePrefix);
      } catch (error) {
        console.error('Error fetching mobile fallback results:', error);
      }
    }

    renderMobileFallbackResults(products, container, searchTerm, localePrefix) {
      const defaultContent = container.querySelector('.mobile-search-default-content');
      if (defaultContent) defaultContent.style.display = 'none';

      const existing = container.querySelector('.mobile-search-results-wrapper');
      if (existing) existing.remove();

      const locale = (window.Shopify?.locale || document.documentElement.lang || 'en').substring(0, 2).toLowerCase();

      const productsText = { zh: '產品', ar: 'المنتجات', es: 'Productos', de: 'Produkte', fr: 'Produits', ja: '商品' };
      const searchForText = { zh: '搜尋', ar: 'البحث عن', es: 'Buscar', de: 'Suchen nach', fr: 'Rechercher', ja: '検索' };

      let html = '';

      if (products.length > 0) {
        html += '<div class="predictive-search__result-group">';
        html += `<h3 class="predictive-search__heading">${productsText[locale] || 'Products'}</h3>`;
        products.forEach(product => {
          html += `
            <a href="${product.url}" class="mobile-predictive-search__item">
              ${product.image ? `<img src="${product.image}" alt="${product.title}" class="mobile-predictive-search__item-image">` : ''}
              <div class="mobile-predictive-search__item-content">
                ${product.vendor ? `<div class="mobile-predictive-search__item-vendor">${product.vendor}</div>` : ''}
                <div class="mobile-predictive-search__item-heading">${product.title}</div>
                ${product.price ? `<div class="mobile-predictive-search__item-price" style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                  <span style="font-weight: 700;">${product.price}</span>
                  ${product.compare_at_price ? `<span style="text-decoration: line-through; color: #666; font-size: 0.85em;">${product.compare_at_price}</span>` : ''}
                  ${product.badge ? `<span style="color: #f4a340; font-weight: 700; font-size: 0.85em;">${product.badge}</span>` : ''}
                </div>` : ''}
              </div>
            </a>
          `;
        });
        html += '</div>';
      }

      html += `
        <div class="predictive-search__search-for-button">
          <a href="${localePrefix}/search?q=${encodeURIComponent(searchTerm)}" class="predictive-search__item-link">
            ${searchForText[locale] || 'Search for'} "${searchTerm}" →
          </a>
        </div>
      `;

      const wrapper = document.createElement('div');
      wrapper.className = 'mobile-search-results-wrapper';
      wrapper.innerHTML = html;
      container.appendChild(wrapper);
    }
    
    renderPredictiveSearchResults(results, container, searchTerm) {
  // Hide default content when showing search results
  const defaultContent = container.querySelector('.mobile-search-default-content');
  if (defaultContent) {
    defaultContent.style.display = 'none';
  }
  
  // Get locale once at the beginning
  const locale = document.documentElement.lang || 
               document.querySelector('html').getAttribute('lang') || 
               window.Shopify?.locale || 
               'en';

  console.log('Detected locale:', locale, 'HTML lang:', document.documentElement.lang);

  
  // Translation objects
  const productsText = {
    'zh-CN': '产品',
    'zh-TW': '產品',
    'fr': 'Produits',
    'de': 'Produkte',
    'es': 'Productos',
    'ja': '製品',
    'ar': 'منتجات',
    'en': 'Products'
  };
  
  const searchForText = {
    'zh-CN': '搜索',
    'zh-TW': '搜尋',
    'fr': 'Rechercher',
    'de': 'Suchen nach',
    'es': 'Buscar',
    'ja': '検索',
    'ar': 'البحث عن',
    'en': 'Search for'
  };
  
  let html = '';
  
  // Products
  if (results.products && results.products.length > 0) {
    html += '<div class="predictive-search__result-group">';
    html += `<h3 class="predictive-search__heading">${productsText[locale] || 'Products'}</h3>`;
    results.products.forEach(product => {
      // Simple currency fix - just add symbol if price exists and doesn't already have it
      let displayPrice = '';
      if (product.price) {
        const currencySymbol = window.shopCurrency?.symbol || '$';
        // Check if price already contains currency symbol
        if (product.price.includes(currencySymbol)) {
          displayPrice = product.price;
        } else {
          // Remove any existing symbols and add the correct one
          const cleanPrice = product.price.replace(/[^\d.,]/g, '');
          displayPrice = currencySymbol + cleanPrice;
        }
      }
      
      html += `
        <a href="${product.url}" class="mobile-predictive-search__item">
          ${product.image ? `<img src="${product.image}" alt="${product.title}" class="mobile-predictive-search__item-image">` : ''}
          <div class="mobile-predictive-search__item-content">
            ${product.vendor ? `<div class="mobile-predictive-search__item-vendor">${product.vendor}</div>` : ''}
            ${product.rating ? `<div class="mobile-predictive-search__item-rating">(${product.rating})</div>` : ''}
            <div class="mobile-predictive-search__item-heading">${product.title}</div>
            ${displayPrice ? `<div class="mobile-predictive-search__item-price">${displayPrice}</div>` : ''}
          </div>
        </a>
      `;
    });
    html += '</div>';
  }
  
  // Pages
  if (results.pages && results.pages.length > 0) {
    html += '<div class="predictive-search__result-group">';
    html += '<h3 class="predictive-search__heading">' + ({ 'zh-CN': '页面', 'zh-TW': '頁面', 'fr': 'Pages', 'de': 'Seiten', 'es': 'Páginas', 'ja': 'ページ', 'ar': 'الصفحات' }[document.documentElement.lang] || 'Pages') + '</h3>';
    results.pages.forEach(page => {
      html += `
        <a href="${page.url}" class="mobile-predictive-search__item">
          <div class="mobile-predictive-search__item-content">
            <div class="mobile-predictive-search__item-heading">${page.title}</div>
          </div>
        </a>
      `;
    });
    html += '</div>';
  }
  
  // Articles
  if (results.articles && results.articles.length > 0) {
    html += '<div class="predictive-search__result-group">';
    html += '<h3 class="predictive-search__heading">Articles</h3>';
    results.articles.forEach(article => {
      html += `
        <a href="${article.url}" class="mobile-predictive-search__item">
          <div class="mobile-predictive-search__item-content">
            <div class="mobile-predictive-search__item-heading">${article.title}</div>
          </div>
        </a>
      `;
    });
    html += '</div>';
  }
  
  // Search for button
  html += `
    <div class="predictive-search__search-for-button">
      <button type="submit" class="predictive-search__item-link">
        ${searchForText[locale] || 'Search for'} "${searchTerm}"
      </button>
    </div>
  `;
  
  // Create a wrapper for search results
  const resultsWrapper = document.createElement('div');
  resultsWrapper.className = 'mobile-search-results-wrapper';
  resultsWrapper.innerHTML = html;
  
  // Append to container (after default content)
  container.appendChild(resultsWrapper);
}



    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-faq"] && !Shopify.designMode) return;
  try {
    
  // Fixed initialization that prevents auto-closing the clicked question
  document.addEventListener('DOMContentLoaded', function() {
    // First check if jQuery is available
    if (typeof jQuery === 'undefined') {
      console.error('FAQ component requires jQuery but it was not found.');
      return;
    }
    
    // Use jQuery now that we know it's available
    const $ = jQuery;
    
    // Track initialization and prevent multiple bindings
    let isInitialized = false;
    
    function initializeFAQs() {
      // Only run once
      if (isInitialized) return;
      isInitialized = true;
      
      console.log('Initializing FAQ component...');
      
      // Make sure answers are initially hidden via JavaScript
      $('[data-faq-answer]').hide();
      
      // Important: Remove ALL previous click handlers from document and questions
      $(document).off('click', '[data-faq-question]');
      $('[data-faq-question]').off('click');
      
      // Add our own click handlers with namespaced event and debounce to prevent duplicate triggers
      $(document).on('click.shopifyExplorerFAQ', '[data-faq-question]', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // More aggressive than stopPropagation
        
        const $question = $(this);
        const $answer = $question.next('[data-faq-answer]');
        const isExpanding = !$question.hasClass('active');
        
        // Only proceed if we're not in the middle of an animation
        if ($answer.is(':animated')) {
          return;
        }
        
        // Toggle current question's active state
        $question.toggleClass('active');
        
        // Toggle the answer visibility
        if (isExpanding) {
          // Opening this answer
          $answer.slideDown(400).addClass('active');
          
          // Close other FAQs (accordion style)
          $('[data-faq-question]').not($question).removeClass('active');
          $('[data-faq-answer]').not($answer).slideUp(400).removeClass('active');
        } else {
          // Closing this answer
          $answer.slideUp(400).removeClass('active');
        }
      });
      
      // Handle Shopify editor events
      $(document).on('shopify:block:select', function(event) {
        const $question = $(event.target).find('[data-faq-question]');
        const $answer = $(event.target).find('[data-faq-answer]');
        
        $question.addClass('active');
        $answer.slideDown(400).addClass('active');
      });
      
      $(document).on('shopify:block:deselect', function(event) {
        const $question = $(event.target).find('[data-faq-question]');
        const $answer = $(event.target).find('[data-faq-answer]');
        
        $question.removeClass('active');
        $answer.slideUp(400).removeClass('active');
      });
      
      // Handle expand_questions setting
      if ($('body').find('[data-expand-questions="true"]').length > 0) {
        $('[data-faq-question]').addClass('active');
        $('[data-faq-answer]').show().addClass('active');
      }
      
      console.log('FAQ component successfully initialized');
    }
    
    // Initialize only once
    initializeFAQs();
    
    // No setTimeout initialization - this could be causing duplicate handlers
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skincare-page-faq"] && !Shopify.designMode) return;
  try {
    

  window.onload = function() {
        let $ = window.jQuery;
        $(function() {
        $('body').on('click', '.shopify_explorer_faq__question', function() {
          $(this).next('.shopify_explorer_faq__answer').slideToggle(450).toggleClass('active');
          $(this).toggleClass('active');
        });
          $('.shopify_explorer_faq__question').not(this).next('.shopify_explorer_faq__answer').slideUp(450);
        $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
          $(event.target).find('.shopify_explorer_faq__answer').slideDown(450);
        });
        $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
          $(event.target).find('.shopify_explorer_faq__answer').slideUp(450);
        });
      });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-desktop"]) return;
  try {
    
  if (!window.productInfoTabTrackingBound) {
    window.productInfoTabTrackingBound = true;

    document.addEventListener('click', function (event) {
      if (!event.isTrusted || window.Shopify?.designMode || !(event.target instanceof Element)) return;

      const tab = event.target.closest('button[data-product-info-tab]');
      if (!tab || typeof window.mixpanel?.track !== 'function') return;
      if (tab.dataset.tabLayout === 'mobile_accordion' && tab.getAttribute('aria-expanded') !== 'true') return;

      window.mixpanel.track('Product Info Tab Clicked', {
        tab_name: tab.dataset.productInfoTab,
        product_viewed: tab.dataset.productViewed,
        layout: tab.dataset.tabLayout
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
